import { render } from "./PhotoCategoryList.vue?vue&type=template&id=b296be70"
import script from "./PhotoCategoryList.vue?vue&type=script&lang=js"
export * from "./PhotoCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__